import { Button, Paper, Typography } from '@mui/material';
import Image from '../Image/Image';
import {
  markerIcons
} from '../../utils/MapUtils';
import CampaignIcon from '@mui/icons-material/Campaign';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';

import './AgentStatsCard.scss';

function StatBoard({statName, statCTALabel, totalNumber, totalNumOpened, totalNumInProgres,
  totalNumFinished, handleNavigateToDenounces}) {
  return (
    <div className="stat-board">
      <Typography variant="p" component="p">
        <b>{statName}</b>
      </Typography>
      <div className="stat-info-container">
        <div className="stats-container">
          <Paper
            elevation={1}
            className="stat">
            <Image className="stat-ico" src={markerIcons['opened'].icon} />
            <span className="value">{totalNumOpened}</span>
          </Paper>
          <Paper
            elevation={1}
            className="stat">
            <Image className="stat-ico" src={markerIcons['in-progress'].icon} />
            <span className="value">{totalNumInProgres}</span>
          </Paper>
          <Paper
            elevation={1}
            className="stat">
            <Image className="stat-ico" src={markerIcons['closed'].icon} />
            <span className="value">{totalNumFinished}</span>
          </Paper>
        </div>
        <Paper
          elevation={2}
          className="cta-container">
          <Button onClick={handleNavigateToDenounces}>
            {statCTALabel}
          </Button>
        </Paper>
      </div>
    </div>
  );
}

function AgentStatsCard({
  className,
  totalNumDenounces, totalNumOpenedDenounces, totalNumInProgresDenounces, totalNumFinishedDenounces,
  totalNumFocus, totalNumOpenedFocus, totalNumInProgresFocus, totalNumFinishedFocus,
  handleNavigateToDenounces, handleNavigateToVectorFoci
}) {
  const classes = `agent-stats-card ${className ? className : ''}`;
  return (
    <div className={classes}>
      <StatBoard
        statName="Denúncias"
        statCTALabel={(
          <div className="card-cta">
            <CampaignIcon />
            <span>Denúncias</span>
          </div>
        )}
        totalNumber={totalNumDenounces}
        totalNumOpened={totalNumOpenedDenounces}
        totalNumInProgres={totalNumInProgresDenounces}
        totalNumFinished={totalNumFinishedDenounces}
        handleNavigateToDenounces={handleNavigateToDenounces}
      />
      <StatBoard
        statName="Focos"
        statCTALabel={(
          <div className="card-cta">
            <ImageSearchIcon />
            <span>Focos</span>
          </div>
        )}
        totalNumber={totalNumFocus}
        totalNumOpened={totalNumOpenedFocus}
        totalNumInProgres={totalNumInProgresFocus}
        totalNumFinished={totalNumFinishedFocus}
        handleNavigateToDenounces={handleNavigateToVectorFoci}
      />
    </div>
  )
}

export default AgentStatsCard;